module.exports = __webpack_public_path__ + "static/space-discovery-7688f51af48489d473010e1a4f6ef925.png";